<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <h2 class="Title">
                레코딩 파일
            </h2>

            <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/admin/Encoding-Server">레코딩 파일</a>
            </div>
        </div>

            <WowzaLivestreamRecordingForm />

    </div>
    
</template>
    
<script>
import WowzaLivestreamRecordingForm from '@/components/livestream/WowzaLivestreamRecordingForm.vue';

export default {
    components: {
        WowzaLivestreamRecordingForm,
    },
}
</script>

<style lang="scss" scoped></style>